import VueGtm from "@gtm-support/vue2-gtm";
import Vue from "vue";
export function setVueGtm(gtmTagId, nodeENV,  router) {
  Vue.use(VueGtm, {
    id: gtmTagId,
    enabled: nodeENV !== "development",
    debug: true,
    loadScript: true,
    vueRouter: router,
  });
}
